// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zi6A5","textarea":"styles_textarea__1MQsk"};